import { useMutation } from "@apollo/client";

import { GqlMedia } from "~/__generated__";

import { MapEditorEcologicalFunctionPanel_EcologicalFunctionUpdateDocument } from "./mutations.generated";

export interface EcologicalFunctionUpdateFormValues {
    answers: Record<string, string | null>;
    ecologicalFunctionTypeId: string;
    speciesIds: string[];
    medias: GqlMedia[];
    preciseLocation: Record<string, string | null>;
}

export function useUpdateEcologicalFunctionMutation() {
    const [mutate, result] = useMutation(MapEditorEcologicalFunctionPanel_EcologicalFunctionUpdateDocument);

    const updateEcologicalFunction = (
        ecologicalFunctionId: string,
        createdAt: string,
        { medias, answers, ecologicalFunctionTypeId, preciseLocation, speciesIds }: EcologicalFunctionUpdateFormValues,
    ) =>
        mutate({
            variables: {
                input: {
                    ecologicalFunctionId: ecologicalFunctionId,
                    createdAt: createdAt,
                    mediaIds: medias.map(media => media.id),
                    answers: answers,
                    ecologicalFunctionTypeId: ecologicalFunctionTypeId,
                    preciseLocation: preciseLocation,
                    speciesIds: speciesIds,
                },
            },
        });

    return [updateEcologicalFunction, result] as const;
}
